import {
  CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_BEGIN,
  CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_SUCCESS,
  CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_FAILURE,
  CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteCustomDataMapping(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/custom-data-mapping/${args.uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_SUCCESS,
              data: res.data,
            });
            toast.success('Mapping Deleted Successfully');
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCustomDataMappingError() {
  return {
    type: CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_BEGIN:
      return {
        ...state,
        deleteCustomDataMappingPending: true,
        deleteCustomDataMappingError: null,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_SUCCESS:
      const customDataMappings = state.customDataMappings.filter(
        (mapp) => mapp.uuid !== action.data.uuid,
      );
      return {
        ...state,
        deleteCustomDataMappingPending: false,
        deleteCustomDataMappingError: null,
        customDataMappings,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_FAILURE:
      return {
        ...state,
        deleteCustomDataMappingPending: false,
        deleteCustomDataMappingError: action.data.error,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_DISMISS_ERROR:
      return {
        ...state,
        deleteCustomDataMappingError: null,
      };

    default:
      return state;
  }
}
